/**
 * Trigger a PNG file download from a data URL via Blob (avoids Chrome
 * "Can't open this page" when data URLs are too large for navigation).
 * @param {string} dataUrl
 * @param {string} fileName
 */
export async function downloadPngDataUrl(dataUrl, fileName) {
    if (!dataUrl || typeof dataUrl !== "string") {
        throw new Error("Nothing to download");
    }
    let blob;
    if (dataUrl.startsWith("blob:")) {
        const res = await fetch(dataUrl);
        if (!res.ok) throw new Error("Failed to read capture");
        blob = await res.blob();
    } else if (dataUrl.startsWith("data:")) {
        const res = await fetch(dataUrl);
        blob = await res.blob();
    } else {
        throw new Error("Unsupported image data");
    }
    const objectUrl = URL.createObjectURL(blob);
    try {
        const link = document.createElement("a");
        link.href = objectUrl;
        link.download = fileName;
        link.rel = "noopener";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } finally {
        window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1500);
    }
}
